import { Expose } from "class-transformer";

const DEFAULT_INDEX_UID = "product";

export class ProductSearchQueryDto {
  @Expose()
  indexUid: string = DEFAULT_INDEX_UID;

  @Expose()
  q!: string;

  @Expose()
  limit!: number;

  @Expose()
  attributesToSearchOn!: string[];

  @Expose()
  attributesToRetrieve!: string[];

  @Expose()
  matchingStrategy!: string;

  @Expose()
  filter?: string[][];
}
